import { useEffect } from 'react';

import { useParams, useSelector } from 'third-party';

import { useApp } from 'modules/app';

import { appSelectors } from 'selectors';

import { APIUserType } from 'types/api';

export const useOrganization = () => {
  const { organizationId } = useParams();
  const userId = useSelector(appSelectors.userId);
  const isSuperAdmin = useSelector(appSelectors.isSuperAdmin);
  const organizations = useSelector(appSelectors.organizations);
  const selectedOrganization = useSelector(appSelectors.selectedOrganization);
  const { selectOrganization, viewExternalOrganization } = useApp();

  useEffect(() => {
    if (!userId) {
      return;
    }

    if (!organizationId) {
      // Left the organization context (e.g. "back to home") — clear any
      // lingering selection so the sidebar shows the home menu, not the org one.
      if (selectedOrganization?.organization.id) {
        selectOrganization(undefined);
      }
      return;
    }

    if (selectedOrganization?.organization.id === organizationId) {
      return;
    }

    // Real memberships only — synthetic external-org entries are tagged SuperAdmin.
    const isMember = organizations?.some(
      it =>
        it.organization.id === organizationId &&
        it.userType !== APIUserType.SuperAdmin,
    );

    if (isMember || !isSuperAdmin) {
      selectOrganization(organizationId);
    } else {
      // Super admin deep-linking into an organization they are not a member of:
      // fetch it and set it as the current (external) organization.
      viewExternalOrganization(organizationId);
    }
  }, [
    organizationId,
    userId,
    isSuperAdmin,
    organizations,
    selectedOrganization?.organization.id,
    selectOrganization,
    viewExternalOrganization,
  ]);
};
